<template>
  <div>
    <yk-report />
  </div>
</template>

<script>
// 获取接口地址
import YkReport from '../components/ykbb/ykReport.vue'

export default {
  name: 'Ykbb',
  components: {
    // sideMenu,
    // Header,
    YkReport
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
